export default __webpack_public_path__ + "static/media/BHGC_250x250.0acbc36f.png";